import React from 'react';
import { Point, Name, Input } from './styles.js';
export default function InputField(_ref) {
  var id = _ref.id,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'text' : _ref$type,
      name = _ref.name,
      placeholder = _ref.placeholder,
      required = _ref.required,
      disabled = _ref.disabled;
  return /*#__PURE__*/React.createElement(Point, null, /*#__PURE__*/React.createElement(Name, {
    htmlFor: id
  }, name), /*#__PURE__*/React.createElement(Input, {
    type: type,
    id: id,
    name: name || id,
    placeholder: placeholder || name,
    required: required,
    disabled: disabled
  }));
}